module.exports = __webpack_public_path__ + "img/flt_pt_fine_bolt.prt.0bf3d165.jpg";